'use client';
import * as React from 'react';
import { styled } from '@mui/material/styles';
import { grey } from '@mui/material/colors';
import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';

const StyledBox = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'light' ? '#fff' : grey[800],
}));

/*
const Puller = styled(Box)(({ theme }) => ({
    height: 6,
    backgroundColor: theme.palette.mode === 'light' ? '#000000' : '#FFFFFF',
    borderRadius: '100px',
    position: 'absolute',
    top: window.innerHeight * 0.91,
    left: 'calc(50% - 60px)',
}));
*/
const StyledSwipeableDrawer = styled(SwipeableDrawer)<{
    horizontalPadding?: number;
    verticalPadding?: number;
}>(({ horizontalPadding, verticalPadding }) => ({
    '& .MuiPaper-root': {
        width: '100vw',
        height: 'auto',
        maxHeight: '100%',
        borderTopLeftRadius: '16px',
        borderTopRightRadius: '16px',
        padding: `${verticalPadding ?? 16}px ${horizontalPadding ?? 16}px 0px`,
        overflow: 'auto',
        transition: 'none !important',
        transform: 'none !important',
    },
    '& .MuiBackdrop-root': {
        backdropFilter: 'blur(3px)',
        opacity: '1 !important',
    },
}));

const BottomSheetAnchored: React.FC<{
    children: React.ReactElement[] | React.ReactElement;
    open: boolean;
    setOpen: (flag: boolean) => void;
    scrollIndex?: number;
    heightInput?: string;
    horizontalPadding?: number;
    verticalPadding?: number;
}> = ({ open, setOpen, horizontalPadding, verticalPadding, children }) => {
    const toggleDrawer = (newOpen: boolean) => () => {
        setOpen(newOpen);
    };

    return (
        <div
            className={'z-[2000]'}
            style={{
                backdropFilter: 'blur(3px)',
                backgroundColor: 'rgba(0,0,30,1.7)',
            }}
        >
            {/* @ts-ignore */}
            <StyledSwipeableDrawer
                anchor="bottom"
                open={open}
                onClose={toggleDrawer(false)}
                onOpen={toggleDrawer(true)}
                swipeAreaWidth={0}
                disableSwipeToOpen={true}
                disableBackdropTransition={true}
                disableDiscovery={true}
                horizontalPadding={horizontalPadding}
                verticalPadding={verticalPadding}
                ModalProps={{
                    keepMounted: true,
                }}
            >
                <StyledBox
                    sx={{
                        height: '100%',
                    }}
                >
                    <>{children}</>
                </StyledBox>
                {/* <StyledBox
          sx={{
            position: 'absolute',
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            visibility: 'visible',
            right: 0,
            left: 0,
          }}
        > */}
                {/* <Puller /> */}
                {/* </StyledBox> */}
            </StyledSwipeableDrawer>
        </div>
    );
};
export default BottomSheetAnchored;
